import { JSX, KeyboardEvent, RefAttributes, TextareaHTMLAttributes, useCallback } from 'react'

import { Editable, RenderElementProps, RenderLeafProps } from 'slate-react'
import { RenderTextProps } from 'slate-react/dist/components/editable'

export type SlateEditorProps = {
    renderElement?: (props: RenderElementProps) => JSX.Element
    renderLeaf?: (props: RenderLeafProps) => JSX.Element
    renderText?: (props: RenderTextProps) => JSX.Element

    /**
     * This prop should be memoized, as it is used as a dependency for `useCallback` internally
     */
    onKeyDownHandlers?: ((event: KeyboardEvent<HTMLDivElement>) => void)[]
    /**
     * Native `beforeinput`. Return true to make Slate skip its own handling. Without a return value Slate
     * checks `defaultPrevented`, which stays false for non-cancelable events (most of them on Android).
     */
    onDOMBeforeInput?: (event: InputEvent) => boolean | void
} & TextareaHTMLAttributes<HTMLDivElement> &
    RefAttributes<HTMLDivElement>

export const SlateEditor = (props: SlateEditorProps) => {
    const { onKeyDownHandlers = [], ...rest } = props

    const onKeyDown = useCallback(
        (event: KeyboardEvent<HTMLDivElement>) => {
            for (const handler of onKeyDownHandlers) {
                handler(event)
            }
        },
        [onKeyDownHandlers],
    )

    return (
        <Editable
            autoFocus
            onKeyDown={onKeyDown}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...rest}
        />
    )
}
